/***********************************************************************************
 * Pairing View
 *
 * @author Zip Co - Plugin Team
 *
 ***********************************************************************************/

import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';

import Spinner from '@/components/Spinner';
import PairingForm from '@/components/PairingForm';
import PaymentRequest from '@/models/Vend/PaymentRequest';
import config from '@/config/client';
import Token from '@/models/Token';

@Component({
    metaInfo(): object {
        return {
            title: config.views.pairing.title
        };
    },
    computed: {
        ...mapGetters({
            env: 'getEnv',
            amount: 'getAmount'
        })
    },
    methods: {
        ...mapActions({
            updateAuthStatus: 'updateAuthStatus',
            updateStatesFromPaymentRequest: 'updateStatesFromPaymentRequest',
            setToken: 'setToken',
            toggleCloseButton: 'setCloseButton'
        })
    },
    components: {
        Spinner,
        PairingForm
    }
})
class Pairing extends Vue {
    public $router: any;
    public $route: any;
    public $http: any;

    private readonly env!: string;

    private vendLogo: string = config.views.pairing.vendLogo;
    private zipLogo: string = config.views.pairing.zipLogo;
    private message: string = config.views.pairing.defaultMessage.replace('{env}', this.isProduction ? '' : 'Sandbox ');

    private loading: boolean = true;
    private amount!: number;
    private error: string = '';

    private updateAuthStatus!: (isAuth: boolean) => Promise<void>;
    private updateStatesFromPaymentRequest!: (PaymentRequest: PaymentRequest) => Promise<void>;
    private setToken!: (token: Token) => Promise<void>;
    private toggleCloseButton!: (enabled: boolean) => Promise<void>;

    public async mounted(): Promise<void> {
        const paymentRequest: PaymentRequest = this.$route.query;
        this.toggleCloseButton(true);
        if (paymentRequest.amount) {
            // update request status
            this.updateStatesFromPaymentRequest(paymentRequest);
            // check authentication
            await this.auth();
        } else {
            this.loading = false;
            this.error = config.views.pairing.invalidPurchaseMessage;
        }
    }

    /**
     * is currently running on production
     */
    private get isProduction(): boolean {
        return this.env === 'prod';
    }

    /**
     * Check authentication
     */
    private async auth(): Promise<void> {
        try {
            const { data: token } = await this.$http.post('/api/pairing/auth', this.$route.query);

            if (token) {
                this.updateAuthStatus(true);
                this.setToken(token);
                this.$router.push({
                    name: this.amount >= 0 ? 'purchase' : 'refund'
                });
            }
        } catch (ex) {
            console.error('Authentication Failed:', ex.response.data.message);
        }

        this.loading = false;
    }
}

export default Pairing;
